import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'

import type { IQuestionGroupActor } from 'modules/surveys/store/models/QuestionGroup'

interface Props {
  respondent: IQuestionGroupActor | null | undefined
}

export default function MeAnonymousLabel({ respondent }: Props) {
  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      {respondent && (
        <UserAvatar
          size="s48"
          user={{ avatar: respondent.avatar ?? undefined, fullName: respondent.full_name ?? '' }}
        />
      )}
      <Text.Normal weight="medium">{i18n.t('surveys.form.responses.me_anonymous')}</Text.Normal>
    </Box>
  )
}
